import { useEffect, useState } from "react";
import { AuraBlob } from "./AuraBlob";

const messages = [
  "Checking the group chat archives…",
  "Measuring aura leakage…",
  "Consulting the vibe department…",
  "Looking for unnecessary ellipses…",
  "Auditing the “back in my day” reserves…"
];

type LoadingCardProps = {
  onCancel: () => void;
};

export function LoadingCard({ onCancel }: LoadingCardProps) {
  const [index, setIndex] = useState(0);
  const [showCancel, setShowCancel] = useState(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;
    const interval = window.setInterval(() => setIndex((value) => (value + 1) % messages.length), 1400);
    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeout = window.setTimeout(() => setShowCancel(true), 5000);
    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <section className="result-card loading-card" aria-busy="true">
      <AuraBlob size="result" mood="loading" />
      <div>
        <h2>Checking your aura</h2>
        <p aria-hidden="true">{messages[index]}</p>
        <span className="sr-only">Checking your aura.</span>
        {showCancel ? (
          <button type="button" className="text-button" onClick={onCancel}>
            Cancel check
          </button>
        ) : null}
      </div>
    </section>
  );
}
